function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = function sizes() {
  return {
    small: {
      paddingLeft: 4,
      fontSize: 11,
      lineHeight: '16px'
    },
    tiny: {
      paddingLeft: 4,
      fontSize: 12,
      lineHeight: '16px'
    },
    medium: {
      paddingLeft: 8,
      fontSize: 14,
      lineHeight: '20px'
    },
    large: {
      paddingLeft: 8,
      fontSize: 16,
      lineHeight: '24px'
    }
  };
};

export var getRadioLabelStyles = function getRadioLabelStyles(_ref) {
  var size = _ref.size;
  return _objectSpread({
    alignItems: 'flex-end'
  }, sizes()[size]);
};

var radioRootSizes = function radioRootSizes() {
  return {
    tiny: {
      width: '20px',
      height: '20px'
    },
    small: {
      width: '20px',
      height: '20px'
    },
    medium: {
      width: '24px',
      height: '24px'
    },
    large: {
      width: '32px',
      height: '32px'
    }
  };
};

export var getRadioRootStyles = function getRadioRootStyles(_ref2) {
  var size = _ref2.size;
  return _objectSpread({
    padding: '6px',
    fontSize: '11px'
  }, radioRootSizes()[size]);
};

var iconSizes = function iconSizes() {
  return {
    tiny: {
      width: '10px',
      height: '10px'
    },
    small: {
      width: '10px',
      height: '10px'
    },
    medium: {
      width: '16px',
      height: '16px'
    },
    large: {
      width: '20px',
      height: '20px'
    }
  };
};

export var getRadioIconStyles = function getRadioIconStyles(_ref3) {
  var size = _ref3.size;
  return _objectSpread({}, iconSizes()[size]);
};